import Highcharts from 'highcharts'

const CUSTOM_CHART_COLORS = window.CUSTOM_CHART_COLORS

/**
 * Takes the device specifications and looks up the corresponsing color.
 *
 * @function
 *
 * @param {object} opts
 * @param {string} opts.deviceName - Has to be the device name (required).
 * @param {string} opts.deviceClass - Has to be the device classification, if consumer (con) or generator (gen), or something else (required).
 * @param {integer} opts.countId - Is the number (count) of this device (optional).
 *
 * @return {string}
 */
export function getChartColorForDevice(opts) {
  let c = CUSTOM_CHART_COLORS.fallback // fallback: gray
  try {
    const deviceName = opts.deviceName
    const deviceClass = opts.deviceClass
    if (!deviceName) {
      throw new Error('Extraction of chart color is not possible, because the deviceName option is missing.')
    } else if (!deviceClass) {
      throw new Error('Extraction of chart color is not possible, because the deviceClass option is missing')
    }

    const colors = CUSTOM_CHART_COLORS[deviceName][deviceClass]
    c = extractColor(colors, opts)
  } catch {
    console.warn('Failed to determine chart color. Will use default fallback. Options are:', opts)
  }

  return c
}

/**
 * Takes the measurand specifications and looks up the corresponsing color.
 *
 * @function
 *
 * @param {object} opts
 * @param {string} opts.metric - Has to be the measurand metric, e.g. 'temperature' (required).
 * @param {integer} opts.countId - Is the number (count) of the measurand (optional).
 * @param {boolean} opts.yAxis - a flag to indicate, to lookup the color in the yAxis section (optional, defaults to false)
 *
 * @return {string}
 */
export function getChartColorForMeasurand(opts) {
  let c = CUSTOM_CHART_COLORS.fallback // fallback: gray
  try {
    if (!opts.metric) {
      throw new Error('Input argument "type" is required.')
    }

    const metric = _.camelCase(opts.metric)
    let colors
    if (opts.yAxis) {
      colors = CUSTOM_CHART_COLORS.yAxis[metric]
    } else {
      colors = CUSTOM_CHART_COLORS.measurand[metric]
    }
    c = extractColor(colors, opts)
  } catch {
    console.warn(
      'Failed to determine chart color. Will use default fallback. (Note, "metric" value is camelized.) Options are:',
      opts
    )
  }

  return c
}

export function extractColor(colors, opts) {
  if (!colors) {
    throw new Error('Extraction of chart color failed, because no color definition was found.')
  }

  let num = opts.countId - 1
  if (!num || num < 0) {
    num = 0
  }

  if (typeof colors === 'object') {
    num = num % colors.length
    return colors[num]
  } else if (typeof colors === 'string' && /^[a-zA-Z0-9]{6}$/.test(colors)) {
    return num === 0 ? colors : brightenColor(colors, 0.1 * num)
  } else {
    throw new Error('Failed to interprete chart color definition:', colors)
  }
}

export function brightenColor(color, factor) {
  color = color || CUSTOM_CHART_COLORS.fallback
  let truncatedFactor
  if (Math.abs(factor) > 1.0) {
    truncatedFactor = 0
  } else if (Math.abs(factor) > 0.3) {
    truncatedFactor = Math.sign(factor) * 0.3
  } else {
    truncatedFactor = factor
  }

  return Highcharts.Color(color).brighten(truncatedFactor).get()
}
